import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import Agenda from "../agenda/Agenda";
import { baseUrl } from "../../../resources/Constants";
import { AGENDA_FOCUS_STORAGE_KEY } from "../../../resources/agendaFocusNavigation";
import Unauthorized from "../general/Unauthorized";
import Loading from "../general/Loading";
import { Modal } from "react-bootstrap";

/** Activar solo para depurar AgendaGeneral en desarrollo. */
const DEBUG_AGENDA_GENERAL = false;
const agendaGeneralDebug = (...args) => {
    if (DEBUG_AGENDA_GENERAL) console.log(...args);
};

function AgendaGeneral() {

    const location = useLocation();

    const [unidades, setUnidades] = useState([]);
    const [agendas, setAgendas] = useState([]);
    const [nombreAgenda, setNombreAgenda] = useState();
    const [nombreUnidad, setNombreUnidad] = useState(null);

    // Estados para buscador de citas
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const searchTimeout = useRef(null);
    const searchRef = useRef(null);

    // Estados para validación de permisos
    const [hasPermission, setHasPermission] = useState(null);
    const [loggedIn, setLoggedIn] = useState(false);

    // Mantener estado legacy (acordeón oculto) para compatibilidad temporal
    const [acordeonesAbiertos, setAcordeonesAbiertos] = useState(false);
    const toggleTodosAcordeones = () => setAcordeonesAbiertos(!acordeonesAbiertos);

    // Modales compactos para ganar espacio vertical del calendario
    const [showModalAgenda, setShowModalAgenda] = useState(false);
    const [showModalVistas, setShowModalVistas] = useState(false);
    const [showModalEstados, setShowModalEstados] = useState(false);
    const [showModalBusquedaAvanzada, setShowModalBusquedaAvanzada] = useState(false);

    const [unidad, setUnidad] = useState();
    const [estadosCita, setEstadosCita] = useState([]);
    const [agenda, setAgenda] = useState();
    const [estadoAgendaProfesional, setEstadoAgendaProfesional] = useState('visible');
    const [selectedDate, setSelectedDate] = useState();
    const [selectedTime, setSelectedTime] = useState('');
    const [selectedCitaId, setSelectedCitaId] = useState(null);
    const [focusToken, setFocusToken] = useState(0);
    const [toastMsg, setToastMsg] = useState();
    const [advNombre, setAdvNombre] = useState('');
    const [advAgenda, setAdvAgenda] = useState('');
    const [advEstado, setAdvEstado] = useState('');
    const [advUnidad, setAdvUnidad] = useState('');
    const [advFechaInicio, setAdvFechaInicio] = useState('');
    const [advFechaFin, setAdvFechaFin] = useState('');
    const [advResultados, setAdvResultados] = useState([]);
    const [advLoading, setAdvLoading] = useState(false);

    useEffect(() => {
        // Validación de permisos
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        // Validación híbrida de permisos (nuevo + legacy)
        let tienePermiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'verAgenda');
        } else if (userdata.up && userdata.up.includes('verAgenda')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // 🔒 Usar axios que ya tiene el token configurado
        const requestAgendas = axios.get('/agendas-usuario')
            .then(response => {
                setLoggedIn(true);
                return response.data;
            })
            .catch(error => {
                agendaGeneralDebug('Error cargando agendas:', error);
                setLoggedIn(true);
                return [];
            });

        const requestUnidades = axios.get('/unidades-atencion')
            .then(response => response.data)
            .catch(error => {
                agendaGeneralDebug('Error cargando unidades:', error);
                return [];
            });

        const requestEstadosCita = axios.get('/estados-cita')
            .then(response => response.data)
            .catch(error => {
                agendaGeneralDebug('Error cargando estados:', error);
                return [];
            });

        const result = Promise.all([requestAgendas, requestUnidades, requestEstadosCita]);

        result.then(
            function (response) {
                const loadedAgendas = response[0];
                setAgendas(loadedAgendas);
                setUnidades(response[1]);
                setEstadosCita(response[2]);

                // 🌟 Selección de agenda inicial (Prioridad: URL > Favorita)
                const userdata = JSON.parse(localStorage.getItem('userdata'));
                const query = new URLSearchParams(location.search);
                const profesionalUrl = query.get('profesional');

                if (profesionalUrl && loadedAgendas.length > 0) {
                    const agendaUrl = loadedAgendas.find(a => String(a.id) === String(profesionalUrl));
                    if (agendaUrl) {
                        agendaGeneralDebug('Seleccionando agenda desde URL:', agendaUrl.nombre);
                        asignarAgenda(String(profesionalUrl), agendaUrl.nombre);
                        return; // Prioridad máxima conseguida
                    }
                }

                const hayProfesionalEnUrl = Boolean(new URLSearchParams(location.search).get('profesional'));
                if (!hayProfesionalEnUrl && userdata && userdata.agenda_favorita && loadedAgendas.length > 0) {
                    const favoritaId = String(userdata.agenda_favorita);
                    const fav = loadedAgendas.find(a => String(a.id) === favoritaId);
                    if (fav) {
                        agendaGeneralDebug('Seleccionando agenda favorita por defecto:', fav.nombre);
                        asignarAgenda(favoritaId, fav.nombre);
                    }
                }
            }
        );
    }, []);


    useEffect(() => {
        //console.log('Unidad: '+unidad);
    }, [unidad]);


    const asignarAgenda = (id, nombre) => {
        agendaGeneralDebug('asignarAgenda llamada con:', { id, nombre });
        setAgenda(id);
        setNombreAgenda(nombre);
    }


    function handleCitaAgendada() {

        if (localStorage.getItem('msgtoast')) {
            let msg = localStorage.getItem('msgtoast');
            localStorage.removeItem('msgtoast');
            setToastMsg(msg);
        }
    }

    // Búsqueda de citas con debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (searchTimeout.current) {
            clearTimeout(searchTimeout.current);
        }

        if (value.length < 3) {
            setSearchResults([]);
            setShowResults(false);
            setSearchLoading(false);
            return;
        }

        setSearchLoading(true);
        searchTimeout.current = setTimeout(() => {
            axios.get('/buscar-citas-paciente', { params: { q: value } })
                .then(response => {
                    setSearchResults(response.data);
                    setShowResults(true);
                    setSearchLoading(false);
                })
                .catch(error => {
                    agendaGeneralDebug('Error buscando citas:', error);
                    setSearchResults([]);
                    setShowResults(false);
                    setSearchLoading(false);
                });
        }, 300);
    };

    /** Misma lógica que al elegir un resultado del buscador (reutilizada desde otras pantallas vía sessionStorage). */
    const applyIrAAgendaCita = useCallback((payload) => {
        if (!payload || !payload.agenda_id || !payload.fecha_cita) return;
        const aid = String(payload.agenda_id);
        setAgenda(aid);
        setNombreAgenda(payload.agenda_nombre || '');
        setSelectedDate(payload.fecha_cita);
        setSelectedTime(payload.hora_cita || '');
        const cid = payload.id_cita;
        setSelectedCitaId(cid != null && cid !== '' ? cid : null);
        setFocusToken((prev) => prev + 1);
        requestAnimationFrame(() => {
            const selectAgenda = document.getElementById('agenda');
            if (selectAgenda) selectAgenda.value = aid;
        });
    }, []);

    /** HashRouter: el query va en `location.search`, no en `window.location.search`. */
    useEffect(() => {
        if (!loggedIn || !agendas.length) return;
        const profesionalUrl = new URLSearchParams(location.search).get('profesional');
        if (!profesionalUrl) return;
        const agendaUrl = agendas.find((a) => String(a.id) === String(profesionalUrl));
        if (!agendaUrl) return;
        agendaGeneralDebug('Sincronizar agenda desde URL:', agendaUrl.nombre);
        setAgenda(String(profesionalUrl));
        setNombreAgenda(agendaUrl.nombre);
        requestAnimationFrame(() => {
            const selectAgenda = document.getElementById('agenda');
            if (selectAgenda) selectAgenda.value = String(profesionalUrl);
        });
    }, [location.search, agendas, loggedIn]);

    useEffect(() => {
        if (!loggedIn || agendas.length === 0) return;
        let raw;
        try {
            raw = sessionStorage.getItem(AGENDA_FOCUS_STORAGE_KEY);
        } catch (e) {
            return;
        }
        if (!raw) return;
        let data;
        try {
            data = JSON.parse(raw);
        } catch (e) {
            sessionStorage.removeItem(AGENDA_FOCUS_STORAGE_KEY);
            return;
        }
        if (!data.agenda_id || !data.fecha_cita) {
            sessionStorage.removeItem(AGENDA_FOCUS_STORAGE_KEY);
            return;
        }
        sessionStorage.removeItem(AGENDA_FOCUS_STORAGE_KEY);
        applyIrAAgendaCita({
            agenda_id: data.agenda_id,
            agenda_nombre: data.agenda_nombre,
            fecha_cita: data.fecha_cita,
            hora_cita: data.hora_cita || '',
            id_cita: data.id_cita || null
        });
    }, [loggedIn, agendas, applyIrAAgendaCita]);

    const handleSelectSearchResult = (resultado) => {
        applyIrAAgendaCita({
            agenda_id: resultado.agenda_id,
            agenda_nombre: resultado.agenda_nombre,
            fecha_cita: resultado.fecha_cita,
            hora_cita: resultado.hora_cita || '',
            id_cita: resultado.id_cita ?? resultado.id ?? null
        });
        setSearchTerm('');
        setSearchResults([]);
        setShowResults(false);
    };

    const getBadgeEstadoStyle = (estadoNombre) => {
        const fallback = {
            backgroundColor: 'rgba(23, 162, 184, 0.14)',
            color: '#12889a',
            border: '1px solid rgba(23, 162, 184, 0.28)',
            borderRadius: '999px',
            fontWeight: 700,
            fontSize: '11px',
            padding: '0.18rem 0.46rem'
        };
        if (!estadoNombre || !Array.isArray(estadosCita)) return fallback;
        const estado = estadosCita.find((e) => String(e.nombre || '').toLowerCase() === String(estadoNombre).toLowerCase());
        if (!estado || !estado.color) return fallback;
        return {
            backgroundColor: `${estado.color}20`,
            color: '#2f3a45',
            border: `1px solid ${estado.color}70`,
            borderRadius: '999px',
            fontWeight: 700,
            fontSize: '11px',
            padding: '0.18rem 0.46rem'
        };
    };

    const abrirBusquedaAvanzada = () => {
        setShowModalBusquedaAvanzada(true);
    };

    const ejecutarBusquedaAvanzada = () => {
        setAdvLoading(true);
        const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
        axios.get('/busqueda-citas', {
            params: {
                uid: userdata.user_id,
                nombre: advNombre || '',
                estado_cita: advEstado || '',
                fecha_inicio: advFechaInicio || '',
                fecha_fin: advFechaFin || '',
                profesional: advAgenda || '',
                unidad: advUnidad || ''
            }
        })
            .then((response) => {
                setAdvResultados(response.data || []);
                setAdvLoading(false);
            })
            .catch((error) => {
                agendaGeneralDebug('Error en búsqueda avanzada:', error);
                setAdvResultados([]);
                setAdvLoading(false);
            });
    };

    const seleccionarResultadoAvanzado = (cita) => {
        handleSelectSearchResult({
            id_cita: cita.id,
            id: cita.id,
            agenda_id: cita.id_users,
            agenda_nombre: cita.agenda_nombre,
            fecha_cita: cita.fecha_cita,
            hora_cita: cita.hora_cita,
            estado_cita: cita.estado_cita,
            primer_nombre: cita.primer_nombre,
            segundo_nombre: cita.segundo_nombre,
            primer_apellido: cita.primer_apellido,
            segundo_apellido: cita.segundo_apellido
        });
        setShowModalBusquedaAvanzada(false);
    };

    // Cerrar resultados al hacer click fuera
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (searchRef.current && !searchRef.current.contains(e.target)) {
                setShowResults(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const [verProfesionales, setVerProfesionales] = useState(true);

    const fechaAmigable = useMemo(() => {
        const fechaBase = selectedDate || new Date().toISOString().slice(0, 10);
        const [year, month, day] = fechaBase.split("-").map((valor) => parseInt(valor, 10));
        const fecha = new Date(year, (month || 1) - 1, day || 1);
        const texto = fecha.toLocaleDateString("es-CO", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        });
        return texto.charAt(0).toUpperCase() + texto.slice(1);
    }, [selectedDate]);

    // Protección de ruta estándar
    if (hasPermission === false) {
        return <Unauthorized />;
    }




    if (!loggedIn) {
        return <Loading />;
    }

    return <div className="hold-transition agenda-general-compact">
        <Header />
        <Aside activelink="calendar" />

        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-1 align-items-center">
                        <div className="col-12">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                <li className="breadcrumb-item active">Agenda</li>
                            </ol>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-12">
                            <div className="agenda-general-hero">
                                <p className={`mb-0 agenda-general-hero__title${nombreAgenda ? '' : ' agenda-general-hero__title--placeholder'}`}>
                                    {nombreAgenda || 'Seleccione una Agenda'}
                                </p>
                                <p className="mb-0 agenda-general-hero__date">{fechaAmigable}</p>
                                {nombreUnidad && (
                                    <p className="mb-0 agenda-general-hero__unit">
                                        <i className="fas fa-hospital-alt mr-1"></i>
                                        {nombreUnidad}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">

                        <div className="col-sm-5 grupo-encabezado-agenda old-agenda-accordion">
                            <div className="card-header">
                                <h4 className="card-title w-100">
                                    <button
                                        type="button"
                                        className="btn btn-link d-block w-100 text-left p-0"
                                        onClick={toggleTodosAcordeones}
                                        aria-expanded={acordeonesAbiertos}
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                    >
                                        Calendarios
                                    </button>
                                </h4>
                            </div>
                            <div className={`collapse ${acordeonesAbiertos ? 'show' : ''}`}>
                                <div className="card-body">



                                    <div className={'form-group ' + (verProfesionales ? '' : 'hide')}>
                                        <label htmlFor="profesional">Agenda</label>
                                        <select name="agenda" className="col-sm-10 form-control" id="agenda"
                                            onChange={(e) => {
                                                agendaGeneralDebug('Agenda seleccionada:', e.target.value, e.target.options[e.target.selectedIndex].text);
                                                asignarAgenda(e.target.value, e.target.options[e.target.selectedIndex].text);
                                            }}>
                                            <option value="">Seleccionar agenda...</option>
                                            {agendas.map((agenda) => <option key={agenda.id} value={agenda.id}>{agenda.nombre}</option>)}
                                        </select>

                                        <label htmlFor="appointmentTime">Fecha</label>
                                        <input type="date" className="col-sm-10 form-control" onChange={(e) => setSelectedDate(e.target.value)} />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="unidadFiltro">Unidad de atención</label>
                                        <select name="unidadFiltro" className="col-sm-10 form-control" id="unidadFiltro"
                                            onChange={(e) => {
                                                setUnidad(e.target.value || null);
                                                const selectedOption = e.target.options[e.target.selectedIndex];
                                                setNombreUnidad(e.target.value ? selectedOption.text : null);
                                            }}>
                                            <option value="">Todas las unidades</option>
                                            {unidades.map((uni) => <option key={uni.id} value={uni.id}>{uni.nombre_unidad}</option>)}
                                        </select>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="col-sm-5 grupo-encabezado-agenda old-agenda-accordion">
                            <div className="card-header">
                                <h4 className="card-title w-100">
                                    <button
                                        type="button"
                                        className="btn btn-link d-block w-100 text-left p-0"
                                        onClick={toggleTodosAcordeones}
                                        aria-expanded={acordeonesAbiertos}
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                    >
                                        Vistas
                                    </button>
                                </h4>
                            </div>
                            <div className={`collapse ${acordeonesAbiertos ? 'show' : ''}`}>
                                <div className="card-body">

                                    <label>Cambiar Vista</label>
                                    <div className="form-group botones-grupo-encabezado-agenda">
                                        <Link to="/agenda-recursos" className="col-sm-5 btn btn-primary">Agendas <i className="fas fa-search"></i></Link>
                                        {' '}
                                        <Link to="/agenda-unidades" className="col-sm-5 btn btn-primary">Unidades <i className="fas fa-search"></i></Link>
                                    </div>

                                </div>
                            </div>
                        </div>



















                        <div className="col-sm-5 grupo-encabezado-agenda old-agenda-accordion">
                            <div className="card-header">
                                <h4 className="card-title w-100">
                                    <button
                                        type="button"
                                        className="btn btn-link d-block w-100 text-left p-0"
                                        onClick={toggleTodosAcordeones}
                                        aria-expanded={acordeonesAbiertos}
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                    >
                                        Estados de la Agenda
                                    </button>
                                </h4>
                            </div>
                            <div className={`collapse ${acordeonesAbiertos ? 'show' : ''}`}>
                                <div className="card-body">

                                    <div id="external-events" className="estados-cita-box-compact">
                                        {
                                            estadosCita.map((estadoCita) =>
                                                <div key={estadoCita.id} className="estado-cita-badge" style={{ backgroundColor: estadoCita.color }}>
                                                    <span className="estado-cita-text">{estadoCita.nombre}</span>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="row mb-1 agenda-toolbar-row">
                        <div className="col-12">
                            <div className="agenda-toolbar-box">
                                <div className="row align-items-center">
                                    <div className="col-lg-7 col-md-12">
                                        <div className="grupo-encabezado-agenda agenda-search-wrap" ref={searchRef} style={{ position: 'relative' }}>
                                            <div className="form-group" style={{ marginBottom: 0 }}>
                                                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Buscar paciente por nombre..."
                                                        value={searchTerm}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <button type="button" className="btn btn-outline-secondary agenda-advanced-search-btn" onClick={abrirBusquedaAvanzada} title="Búsqueda avanzada">
                                                        <i className="fas fa-search-plus"></i>
                                                    </button>
                                                </div>
                                                {searchLoading && (
                                                    <small className="text-muted"><i className="fas fa-spinner fa-spin"></i> Buscando...</small>
                                                )}
                                            </div>
                                            {showResults && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    right: 0,
                                                    zIndex: 1050,
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    maxHeight: '300px',
                                                    overflowY: 'auto',
                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                                                }}>
                                                    {searchResults.length === 0 ? (
                                                        <div style={{ padding: '10px 15px', color: '#999' }}>No se encontraron citas para este paciente</div>
                                                    ) : (
                                                        searchResults.map((r) => (
                                                            <div
                                                                key={r.id_cita}
                                                                onClick={() => handleSelectSearchResult(r)}
                                                                style={{
                                                                    padding: '8px 15px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: '1px solid #eee',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                                            >
                                                                <div>
                                                                    <strong>{([r.primer_nombre, r.segundo_nombre, r.primer_apellido, r.segundo_apellido].filter(Boolean).join(' ').trim() || r.cita_paciente || 'Paciente')}</strong>
                                                                    <br />
                                                                    <small className="text-muted">{r.fecha_cita} - {r.agenda_nombre}</small>
                                                                </div>
                                                                <span style={getBadgeEstadoStyle(r.estado_cita)}>{r.estado_cita}</span>
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-12 d-flex flex-wrap align-items-center justify-content-lg-end justify-content-start agenda-toolbar-buttons" style={{ gap: '8px' }}>
                                        <button type="button" className="btn btn-outline-info agenda-option-btn" onClick={() => setShowModalAgenda(true)}>
                                            <i className="far fa-calendar-alt mr-1"></i> Agendas
                                        </button>
                                        <button type="button" className="btn btn-outline-info agenda-option-btn" onClick={() => setShowModalVistas(true)}>
                                            <i className="fas fa-th-large mr-1"></i> Vistas
                                        </button>
                                        <button type="button" className="btn btn-outline-info agenda-option-btn" onClick={() => setShowModalEstados(true)}>
                                            <i className="far fa-dot-circle mr-1"></i> Estados
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-3">

                        <div className="col-sm-3">

                            <div className={'form-group ' + (verProfesionales ? 'hide' : '')}>
                                <label htmlFor="profesional">Unidad de atención</label>
                                <select name="unidad" className="form-control" id="unidad" onChange={(e) => {
                                    setUnidad(e.target.value || null);
                                    const selectedOption = e.target.options[e.target.selectedIndex];
                                    setNombreUnidad(e.target.value ? selectedOption.text : null);
                                }}>
                                    <option></option>
                                    {
                                        unidades.map((uni) => <option key={uni.id} value={uni.id}>{uni.nombre_unidad}</option>)
                                    }
                                </select>

                            </div>

                        </div>
                    </div>


                </div>
            </div>
            <section className="content agenda-content-compact">
                <div className="row">
                    <div className="col-md-12">

                        <div className="container-fluid">
                            <div className={'agenda-profesional ' + estadoAgendaProfesional}>
                                <Agenda
                                    profesionalAsignado={agenda}  // ← Mantener nombre por compatibilidad
                                    usuarioAsigna={agenda}        // ← Mantener nombre por compatibilidad  
                                    nombreProfesionalAsignado={nombreAgenda}  // ← Mantener nombre
                                    nombreUsuarioAsigna={nombreAgenda}        // ← Mantener nombre
                                    unidad={unidad}
                                    bloquearProfesional={false}
                                    eventOverlap={false}
                                    irAFecha={selectedDate}
                                    irAHora={selectedTime}
                                    irACitaId={selectedCitaId}
                                    irAFocusToken={focusToken}
                                    citaAgendada={handleCitaAgendada}
                                />
                            </div>

                        </div>
                    </div>
                </div>


            </section>
        </div>
        <Modal show={showModalAgenda} onHide={() => setShowModalAgenda(false)} centered dialogClassName="agenda-modern-modal">
            <Modal.Header className="agenda-modern-modal__header">
                <Modal.Title className="agenda-modern-modal__title">
                    <span className="agenda-modern-modal__title-icon"><i className="far fa-calendar-alt"></i></span>
                    Seleccionar Agenda
                </Modal.Title>
                <button type="button" className="agenda-modern-modal__close" onClick={() => setShowModalAgenda(false)}>
                    <i className="fas fa-times"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="agenda-modern-modal__body">
                <div className={'form-group ' + (verProfesionales ? '' : 'hide')}>
                    <label htmlFor="agendaModal">Profesional</label>
                    <select
                        name="agendaModal"
                        className="form-control agenda-modern-control"
                        id="agendaModal"
                        value={agenda || ''}
                        onChange={(e) => {
                            asignarAgenda(e.target.value || null, e.target.options[e.target.selectedIndex].text);
                        }}
                    >
                        <option value="">Seleccionar Profesional...</option>
                        {agendas.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="fechaAgendaModal">Fecha</label>
                    <input
                        id="fechaAgendaModal"
                        type="date"
                        className="form-control agenda-modern-control"
                        value={selectedDate || ''}
                        onChange={(e) => setSelectedDate(e.target.value)}
                    />
                </div>
                <div className="form-group mb-0">
                    <label htmlFor="unidadAgendaModal">Unidad de atención</label>
                    <select
                        name="unidadAgendaModal"
                        className="form-control agenda-modern-control"
                        id="unidadAgendaModal"
                        value={unidad || ''}
                        onChange={(e) => {
                            setUnidad(e.target.value || null);
                            const selectedOption = e.target.options[e.target.selectedIndex];
                            setNombreUnidad(e.target.value ? selectedOption.text : null);
                        }}
                    >
                        <option value="">Todas las unidades</option>
                        {unidades.map((uni) => <option key={uni.id} value={uni.id}>{uni.nombre_unidad}</option>)}
                    </select>
                </div>
            </Modal.Body>
        </Modal>

        <Modal show={showModalVistas} onHide={() => setShowModalVistas(false)} centered dialogClassName="agenda-modern-modal">
            <Modal.Header className="agenda-modern-modal__header">
                <Modal.Title className="agenda-modern-modal__title">
                    <span className="agenda-modern-modal__title-icon"><i className="fas fa-th-large"></i></span>
                    Cambiar Vista
                </Modal.Title>
                <button type="button" className="agenda-modern-modal__close" onClick={() => setShowModalVistas(false)}>
                    <i className="fas fa-times"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="agenda-modern-modal__body">
                <div className="d-flex flex-wrap" style={{ gap: '10px' }}>
                    <Link to="/agenda-recursos" className="btn agenda-view-btn" onClick={() => setShowModalVistas(false)}>
                        <i className="far fa-calendar-alt mr-2"></i>Profesionales
                    </Link>
                    <Link to="/agenda-unidades" className="btn agenda-view-btn" onClick={() => setShowModalVistas(false)}>
                        <i className="fas fa-hospital-alt mr-2"></i>Unidades
                    </Link>
                </div>
            </Modal.Body>
        </Modal>

        <Modal show={showModalEstados} onHide={() => setShowModalEstados(false)} centered dialogClassName="agenda-modern-modal">
            <Modal.Header className="agenda-modern-modal__header">
                <Modal.Title className="agenda-modern-modal__title">
                    <span className="agenda-modern-modal__title-icon"><i className="far fa-dot-circle"></i></span>
                    Estados de la Agenda
                </Modal.Title>
                <button type="button" className="agenda-modern-modal__close" onClick={() => setShowModalEstados(false)}>
                    <i className="fas fa-times"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="agenda-modern-modal__body">
                <div className="agenda-states-modern-list">
                    {estadosCita.map((estadoCita) => (
                        <div key={estadoCita.id} className="agenda-state-modern-item" style={{ borderLeftColor: estadoCita.color }}>
                            <span className="agenda-state-modern-dot" style={{ backgroundColor: estadoCita.color }}></span>
                            <span>{estadoCita.nombre}</span>
                        </div>
                    ))}
                </div>
            </Modal.Body>
        </Modal>

        <Modal show={showModalBusquedaAvanzada} onHide={() => setShowModalBusquedaAvanzada(false)} centered dialogClassName="agenda-modern-modal">
            <Modal.Header className="agenda-modern-modal__header">
                <Modal.Title className="agenda-modern-modal__title">
                    <span className="agenda-modern-modal__title-icon"><i className="fas fa-search-plus"></i></span>
                    Búsqueda Avanzada de Citas
                </Modal.Title>
                <button type="button" className="agenda-modern-modal__close" onClick={() => setShowModalBusquedaAvanzada(false)}>
                    <i className="fas fa-times"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="agenda-modern-modal__body">
                <div className="row">
                    <div className="col-md-6 form-group">
                        <label>Paciente</label>
                        <input className="form-control agenda-modern-control" value={advNombre} onChange={(e) => setAdvNombre(e.target.value)} placeholder="Nombre o apellido" />
                    </div>
                    <div className="col-md-6 form-group">
                        <label>Agenda</label>
                        <select className="form-control agenda-modern-control" value={advAgenda} onChange={(e) => setAdvAgenda(e.target.value)}>
                            <option value="">Todas</option>
                            {agendas.map((a) => <option key={`adv-ag-${a.id}`} value={a.id}>{a.nombre}</option>)}
                        </select>
                    </div>
                    <div className="col-md-4 form-group">
                        <label>Estado</label>
                        <select className="form-control agenda-modern-control" value={advEstado} onChange={(e) => setAdvEstado(e.target.value)}>
                            <option value="">Todos</option>
                            {estadosCita.map((e) => <option key={`adv-est-${e.id}`} value={e.id}>{e.nombre}</option>)}
                        </select>
                    </div>
                    <div className="col-md-4 form-group">
                        <label>Unidad</label>
                        <select className="form-control agenda-modern-control" value={advUnidad} onChange={(e) => setAdvUnidad(e.target.value)}>
                            <option value="">Todas</option>
                            {unidades.map((u) => <option key={`adv-uni-${u.id}`} value={u.id}>{u.nombre_unidad}</option>)}
                        </select>
                    </div>
                    <div className="col-12"><hr style={{ margin: '0.15rem 0 0.55rem', borderColor: '#edf2f7' }} /></div>
                    <div className="col-md-6 form-group">
                        <label>Desde</label>
                        <input type="date" className="form-control agenda-modern-control" value={advFechaInicio} onChange={(e) => setAdvFechaInicio(e.target.value)} />
                    </div>
                    <div className="col-md-6 form-group">
                        <label>Hasta</label>
                        <input type="date" className="form-control agenda-modern-control" value={advFechaFin} onChange={(e) => setAdvFechaFin(e.target.value)} />
                    </div>
                </div>
                <div className="d-flex" style={{ gap: '8px' }}>
                    <button className="btn btn-outline-secondary" onClick={() => {
                        setAdvNombre('');
                        setAdvAgenda('');
                        setAdvEstado('');
                        setAdvUnidad('');
                        setAdvFechaInicio('');
                        setAdvFechaFin('');
                        setAdvResultados([]);
                    }}>Limpiar</button>
                    <button className="btn btn-info ml-auto" onClick={ejecutarBusquedaAvanzada} disabled={advLoading}>
                        {advLoading ? 'Buscando...' : 'Buscar'}
                    </button>
                </div>

                <div className="mt-3" style={{ maxHeight: '280px', overflowY: 'auto', border: '1px solid #e8eef4', borderRadius: '10px' }}>
                    {advResultados.length === 0 ? (
                        <div style={{ padding: '10px 12px', color: '#6b7280' }}>Sin resultados aún.</div>
                    ) : (
                        advResultados.map((r) => (
                            <div
                                key={`adv-res-${r.id}`}
                                onClick={() => seleccionarResultadoAvanzado(r)}
                                style={{ padding: '9px 12px', borderBottom: '1px solid #eef3f6', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                <div>
                                    <strong>{([r.primer_nombre, r.segundo_nombre, r.primer_apellido, r.segundo_apellido].filter(Boolean).join(' ').trim() || r.cita_paciente || 'Paciente')}</strong>
                                    <br />
                                    <small className="text-muted">{r.fecha_cita} {r.hora_cita ? `- ${r.hora_cita}` : ''} - {r.agenda_nombre || 'Agenda'}</small>
                                </div>
                                <span style={getBadgeEstadoStyle(r.estado_cita)}>{r.estado_cita}</span>
                            </div>
                        ))
                    )}
                </div>
            </Modal.Body>
        </Modal>

        <Footer showToast={false} delay={0} message={toastMsg} />
        <style>{`
                    .old-agenda-accordion { display: none !important; }
                    .agenda-general-compact .content-header {
                        padding: 8px 0 4px;
                    }
                    .agenda-general-compact .content {
                        padding-top: 0;
                    }
                    .agenda-general-compact .breadcrumb {
                        margin-bottom: 0;
                    }
                    .agenda-content-compact {
                        margin-top: -8px;
                    }
                    .agenda-toolbar-row {
                        align-items: center;
                    }
                    .agenda-toolbar-box {
                        border: 1px solid #e7edf3;
                        border-radius: 12px;
                        background: #fff;
                        padding: 8px 10px;
                    }
                    .agenda-search-wrap {
                        padding: 0;
                    }
                    .agenda-option-btn {
                        border-radius: 10px;
                        font-size: 13px;
                        font-weight: 600;
                        min-width: 110px;
                        padding: 0.4rem 0.8rem;
                    }
                    .agenda-general-compact .fc .fc-toolbar.fc-header-toolbar {
                        margin-bottom: 0.2rem;
                    }
                    .agenda-general-compact .fc .fc-col-header-cell-cushion {
                        padding-top: 1px;
                        padding-bottom: 1px;
                    }
                    .agenda-advanced-search-btn {
                        height: 40px;
                        border-radius: 10px;
                        min-width: 42px;
                    }
                    .agenda-modern-modal .modal-content {
                        border: none;
                        border-radius: 14px;
                        box-shadow: 0 18px 40px rgba(22, 35, 49, 0.26);
                        overflow: hidden;
                    }
                    .agenda-modern-modal__header {
                        border-bottom: 1px solid #edf2f7;
                        padding: 12px 14px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .agenda-modern-modal__title {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 1.1rem;
                        font-weight: 700;
                        color: #2d3742;
                    }
                    .agenda-modern-modal__title-icon {
                        width: 28px;
                        height: 28px;
                        border-radius: 8px;
                        background: rgba(23, 162, 184, 0.13);
                        color: #148395;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.87rem;
                    }
                    .agenda-modern-modal__close {
                        border: 0;
                        background: rgba(50, 58, 69, 0.08);
                        color: #4b5663;
                        width: 30px;
                        height: 30px;
                        border-radius: 999px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .agenda-modern-modal__close:hover {
                        background: rgba(50, 58, 69, 0.15);
                    }
                    .agenda-modern-modal__body {
                        padding: 14px;
                    }
                    .agenda-modern-control {
                        border-radius: 10px !important;
                        border-color: #d6e0e8 !important;
                        min-height: 40px;
                    }
                    .agenda-view-btn {
                        border-radius: 10px !important;
                        background: rgba(50, 58, 69, 0.08) !important;
                        border: 1px solid rgba(50, 58, 69, 0.14) !important;
                        color: #344253 !important;
                        font-weight: 700 !important;
                        padding: 0.48rem 0.95rem !important;
                    }
                    .agenda-view-btn:hover {
                        background: rgba(23, 162, 184, 0.12) !important;
                        border-color: rgba(23, 162, 184, 0.28) !important;
                        color: #117f90 !important;
                    }
                    .agenda-states-modern-list {
                        display: flex;
                        flex-direction: column;
                        gap: 8px;
                    }
                    .agenda-state-modern-item {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        border: 1px solid #e8eef4;
                        border-left: 4px solid #17a2b8;
                        border-radius: 10px;
                        padding: 8px 10px;
                        background: #fbfdff;
                        font-weight: 600;
                        color: #2f3a45;
                    }
                    .agenda-state-modern-dot {
                        width: 10px;
                        height: 10px;
                        border-radius: 999px;
                        flex: 0 0 auto;
                    }
                    .agenda-general-hero {
                        background: #fff;
                        border: 1px solid #dee2e6;
                        border-radius: 12px;
                        border-left: 4px solid #17a2b8;
                        padding: 14px 18px;
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
                    }
                    .agenda-general-hero__title {
                        font-size: 1.25rem;
                        font-weight: 800;
                        color: #323a45;
                        line-height: 1.3;
                    }
                    .agenda-general-hero__title--placeholder {
                        color: #6c757d;
                        font-weight: 700;
                    }
                    .agenda-general-hero__date {
                        font-size: 0.95rem;
                        color: #6c757d;
                        margin-top: 6px;
                        font-weight: 500;
                    }
                    .agenda-general-hero__unit {
                        font-size: 0.82rem;
                        color: #5a6570;
                        margin-top: 8px;
                        font-weight: 600;
                    }
                    @media (max-width: 991px) {
                        .agenda-title-row .col-md-7 {
                            margin-top: 6px;
                        }
                        .agenda-toolbar-buttons {
                            margin-top: 8px;
                        }
                    }
                `}</style>
    </div>

}
export default AgendaGeneral;